// ReservationModalStyles.js
import styled from "styled-components";
import OrnamentImg from "../../assets/images/ornament.png";

const colors = {
  bg: "#000000",
  text: "#1a1a1a",
  white: "#ffffff",
  accent: "#8b8064",
  gold: "#8b8064",
  line: "rgba(0,0,0,0.08)",
  overlay: "rgba(0,0,0,0.55)",
};

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: ${colors.overlay};
  backdrop-filter: blur(2px);
  z-index: 1100;

  /* centrare perfectă, fără „cădere” pe verticală */
  display: flex;
  align-items: center;
  justify-content: center;

  /* ajută pe mobile cu bare vizibile */
  min-height: 100dvh;
  padding: 12px;
`;

export const Modal = styled.div`
  width: 100%;
  max-width: 780px; /* pe desktop rămâne lat */
  color: ${colors.text};
  max-height: 92vh;
  background: transparent;

  /* ridică subtil modalul doar pe desktop */
  transform: translateY(-2vh);

  @media (max-width: 768px) {
    /* ⬇️ mai îngust și mai scund pe mobil */
    width: 92vw;
    max-width: 92vw;
    max-height: 78vh;
    transform: none; /* fără ridicare pe mobil */
  }

  @media (max-width: 480px) {
    width: 90vw;
    max-width: 90vw;
    max-height: 74vh;
  }
`;

// Ornament sub titlu – mai sus
export const HeaderOrnament = styled.div`
  width: 180px;
  height: 22px;
  margin: 6px auto 0; /* era 10px -> acum mai sus */
  background: url(${OrnamentImg}) center/contain no-repeat;
  opacity: 0.95;
`;

// Linie orizontală aurie cu ornament – mai lungă
export const OrnDivider = styled.div`
  position: relative;
  margin: 16px auto 8px;
  height: 24px;

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    width: 46%; /* era 40%, acum mai lung spre interior */
    height: 1px;
    background: rgba(139, 128, 100, 0.75);
  }
  &::before {
    left: 0;
    transform: translateY(-50%);
  }
  &::after {
    right: 0;
    transform: translateY(-50%);
  }

  background: url(${OrnamentImg}) center/120px 22px no-repeat;
  opacity: 0.95;
`;

// Inputuri complet albe
const baseInput = `
  width: 100%;
  border: 1px solid ${colors.line};
  background: #fff; /* inlocuit #fcfcfc ca să nu fie transparent */
  border-radius: 14px;
  padding: 13px 14px;
  font-size: 16px;
  outline: none;
  transition: border-color .2s ease, box-shadow .2s ease, background .2s ease;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);

  &:focus {
    border-color: ${colors.accent};
    box-shadow: 0 0 0 3px rgba(139,128,100,0.25), 0 2px 6px rgba(0,0,0,0.1);
    background: #fff;
  }
  &::placeholder { color: rgba(0,0,0,0.35); }

  @media (max-width: 480px) {
    padding: 12px 12px;
    font-size: 16px;
    border-radius: 12px;
  }
`;

export const Frame = styled.div`
  position: relative;
  background: ${colors.white};
  border-radius: 20px;
  padding: 8px 8px 6px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.32);
  overflow: visible; /* ⬅️ permite cercului să iasă peste margine */
  isolation: isolate; /* ⬅️ stacking context curat */

  /* ⬇️ TOT CONȚINUTUL deasupra pseudo-elementelor */
  & > * {
    position: relative;
    z-index: 1;
  }

  &::before {
    content: "";
    position: absolute;
    inset: 6px;
    border-radius: 14px;
    opacity: 0.04;
    background-image: url("data:image/svg+xml;utf8,\
      <svg xmlns='http://www.w3.org/2000/svg' width='48' height='56' viewBox='0 0 48 56' fill='none'>\
        <g stroke='black' stroke-width='1'>\
          <path d='M12 2 L36 2 L48 22 L36 42 L12 42 L0 22 Z'/>\
          <path d='M12 42 L36 42 L48 62 L36 82 L12 82 L0 62 Z' transform='translate(0,-20)'/>\
          <path d='M-12 22 L12 22 L24 42 L12 62 L-12 62 L-24 42 Z'/>\
        </g>\
      </svg>");
    background-size: 48px 56px;
    background-repeat: repeat;
    pointer-events: none;
    z-index: 0; /* ⬅️ în spatele conținutului */
  }

  &::after {
    content: "";
    position: absolute;
    inset: 8px;
    border-radius: 14px;
    pointer-events: none;
    border: 1px dashed rgba(0, 0, 0, 0.14);
    z-index: 0; /* ⬅️ și acesta în spate */
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    /* aliniat cu noul max-height al modalului */
    max-height: 78vh;
  }

  @media (max-width: 480px) {
    border-radius: 16px;
    padding: 6px;
    max-height: 75vh;
  }
`;

export const Form = styled.form`
  padding: 16px 24px 24px;

  @media (min-width: 768px) {
    padding: 20px 36px 32px; /* mai compact pe desktop */
  }
  @media (max-width: 768px) {
    flex: 1 1 auto;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  @media (max-width: 480px) {
    padding: 12px 12px 14px;
  }
`;

export const Header = styled.div`
  position: relative;
  padding: 34px 42px 8px; /* redus puțin */
  text-align: center;
  flex: 0 0 auto;

  @media (max-width: 480px) {
    padding: 20px 16px 6px;
  }
`;

export const Ribbon = styled.div`
  position: absolute;
  top: -18px; /* mai puțin ieșit în afară */
  left: 50%;
  transform: translateX(-50%);
  width: 44px;
  height: 44px;
  border-radius: 999px;
  background: radial-gradient(
    circle at 30% 30%,
    #fff 0%,
    #fff 45%,
    #f2f2f2 60%,
    #e9e9e9 100%
  );
  box-shadow: inset 0 0 0 2px ${colors.gold}, 0 8px 22px rgba(0, 0, 0, 0.25);
`;

export const Subtitle = styled.div`
  font-size: 17px;
  color: ${colors.gold};
  font-style: italic;
  letter-spacing: 0.3px;
  margin-bottom: 6px;
  @media (max-width: 480px) {
    font-size: 15px;
  }
`;

export const Title = styled.h3`
  margin: 0;
  font-size: 32px; /* mai mic */
  line-height: 1.15;
  font-weight: 800;
  letter-spacing: 0.2px;
  color: #172033;
  font-family: "Georgia", "Times New Roman", Times, serif;
  @media (max-width: 480px) {
    font-size: 24px; /* mai compact pe mobil */
  }
`;

export const Dots = styled.div`
  color: #adadad;
  letter-spacing: 8px;
  margin-top: 4px;
  user-select: none;
`;

export const CloseBtn = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  appearance: none;
  border: 0;
  background: ${colors.white};
  width: 34px;
  height: 34px;
  border-radius: 10px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12), inset 0 0 0 1px ${colors.line};
  cursor: pointer;

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 14px;
    height: 2px;
    background: ${colors.gold};
    transform-origin: center;
  }
  &::before {
    transform: translate(-50%, -50%) rotate(45deg);
  }
  &::after {
    transform: translate(-50%, -50%) rotate(-45deg);
  }

  &:hover {
    filter: brightness(0.98);
  }
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-bottom: 6px;

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: 480px) {
    gap: 12px;
  }
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Label = styled.label`
  font-size: 12px;
  font-weight: 700;
  color: ${colors.gold};
  margin-bottom: 6px;
  letter-spacing: 0.35px;
  text-transform: uppercase;
  @media (max-width: 480px) {
    font-size: 11px;
    margin-bottom: 6px;
  }
`;

export const Input = styled.input`
  ${baseInput}
`;
export const Select = styled.select`
  ${baseInput};
  appearance: none;
  background-image: linear-gradient(45deg, transparent 50%, ${colors.gold} 50%),
    linear-gradient(135deg, ${colors.gold} 50%, transparent 50%);
  background-position: calc(100% - 22px) 55%, calc(100% - 16px) 55%;
  background-size: 7px 7px, 7px 7px;
  background-repeat: no-repeat;
  @media (max-width: 480px) {
    background-position: calc(100% - 18px) 55%, calc(100% - 12px) 55%;
  }
`;
export const Textarea = styled.textarea`
  ${baseInput};
  resize: vertical;
  min-height: 110px;
  @media (max-width: 480px) {
    min-height: 96px;
  }
`;

export const Actions = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  padding-top: 6px;
  padding-bottom: 4px;
  flex: 0 0 auto;
  @media (max-width: 480px) {
    gap: 8px;
    padding-top: 8px;
  }
`;

const baseBtn = `
  appearance: none; border: 0; border-radius: 12px;
  font-weight: 800; letter-spacing: .2px; font-size: 16px;
  padding: 11px 16px; cursor: pointer; display: inline-flex;
  align-items: center; gap: 10px;

  @media (max-width: 480px) {
    font-size: 15px; padding: 10px 14px; border-radius: 12px; gap: 8px;
  }
`;

export const CancelBtn = styled.button`
  ${baseBtn}
  background: rgba(0,0,0,0.06);
  color: ${colors.text};
  box-shadow: inset 0 0 0 1px ${colors.line};
  &:hover {
    background: rgba(0, 0, 0, 0.09);
  }
`;

export const SubmitBtn = styled.button`
  ${baseBtn}
  background: ${colors.gold};
  color: #fff;
  svg {
    display: block;
  }
  &:disabled {
    opacity: 0.65;
    cursor: not-allowed;
    box-shadow: none;
  }
  &:hover:not(:disabled) {
    filter: brightness(0.98);
    transform: translateY(-0.5px);
  }
`;

export const ErrorMsg = styled.div`
  color: #c02b2b;
  font-size: 13px;
  margin-top: 6px;
  @media (max-width: 480px) {
    font-size: 12px;
  }
`;

export const SuccessNote = styled.div`
  position: fixed;
  top: 18px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1201;

  background: #1f8a3e;
  color: #fff;
  padding: 10px 14px;
  border-radius: 12px;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.18);
  font-weight: 700;
  letter-spacing: 0.2px;
  font-size: 14px;

  @media (max-width: 480px) {
    top: 12px;
    font-size: 13px;
    padding: 9px 12px;
  }
`;
